import { render } from "./SendIcon.vue?vue&type=template&id=1208a187"
const script = {}
script.render = render

export default script